

















import Vue from 'vue';
import Vuex from 'vuex';
import store from './store';

import TimeList from './components/TimeList.vue';
import AddItem from './components/AddItem.vue';
import IconBase from './components/IconBase.vue';
import IconEditWhite from './components/icons/IconEditWhite.vue';

export default Vue.extend({
  name: 'app',
  store,
  components: {
    TimeList,
    AddItem,
    IconBase,
    IconEditWhite,
  },
  methods: {
    edit() {
      this.$store.commit('toggleEditing');
    },
    clear() {
      this.$store.commit('clear');
    },
  },
});
